import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { TextField } from '../../../../components/fields';
import { required, email } from '../../../../utilities/validation';
import messages from '../../../../text/messages';
import { FormattedMessage } from 'react-intl';

class ForgotPassword extends React.Component {
    render() {
        const { handleSubmit, submitting } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <Field name="email" validate={[required, email]} component={TextField} placeholder={messages.email} />
                </div>
                <div className="form-group">
                    <button type="submit" className="btn btn-success btn-block" disabled={submitting}>
                        <FormattedMessage {...messages.submit} />
                    </button>
                </div>
            </form>
        );
    }
}

ForgotPassword.defaultProps = {
    handleSubmit: undefined,
    submitting: false
};

ForgotPassword.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool
};

export default reduxForm({ form: 'ForgotPassword', destroyOnUnmount: true })(ForgotPassword);



// WEBPACK FOOTER //
// ./src/pages/account/forms/forgot/index.jsx